(() => {
  const WORDS_PER_MINUTE = 200;
  const SELECTORS = [
    '.rte',
    '.richtext__content',
    '.image-with-text__text',
    '.article-template__content',
    '[data-blog-reading-target="true"]'
  ];

  const countWords = (root) => {
    const nodes = root.querySelectorAll(SELECTORS.join(','));
    let total = 0;
    const seen = new WeakSet();

    nodes.forEach((node) => {
      if (seen.has(node)) return;
      let ancestor = node.parentElement;
      while (ancestor && ancestor !== root) {
        if (seen.has(ancestor)) return;
        ancestor = ancestor.parentElement;
      }
      seen.add(node);

      const text = (node.textContent || '').trim();
      if (!text) return;
      const words = text.split(/\s+/).filter(Boolean);
      total += words.length;
    });

    return total;
  };

  const update = () => {
    const displays = document.querySelectorAll('[data-blog-reading-time-display]');
    if (!displays.length) return;

    const main = document.querySelector('main') || document.body;
    const words = countWords(main);
    if (words === 0) return;

    const minutes = Math.max(1, Math.round(words / WORDS_PER_MINUTE));
    displays.forEach((el) => {
      el.textContent = String(minutes);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
})();
